import React from "react";

export default function LoadingSpinner() {
  return (
    <div className="spinner-container" style={{height:'85vh'}}>
      <div className="loading-spinner">
      </div>
    </div>
  );
}